<script setup lang="ts">
import { toRef } from 'vue';
import DeviceBatteryState from './DeviceBatteryState.vue';
import DeviceConnectionState from './DeviceConnectionState.vue';
import { useDeviceStatusSignalR } from './utils/useDeviceStatusSignalR';

const props = defineProps<{
  deviceId?: string;
  orientation?: 'horizontal' | 'vertical';
}>();

const deviceState = useDeviceStatusSignalR(toRef(() => props.deviceId));
</script>

<template>
  <span
    v-if="deviceState?.state"
    class="device-state d-flex align-content-center justify-content-center align-items-center ga-2"
    :class="{
      'flex-column': orientation === 'vertical',
      'flex-row': orientation === 'horizontal',
    }"
  >
    <DeviceConnectionState :value="deviceState?.state" />
    <DeviceBatteryState :value="deviceState?.batteryInformation" />
  </span>
</template>
